document.addEventListener('DOMContentLoaded', function () {
  var stickyBar = document.querySelector('[data-opendots-overview-sticky]');

  if (!stickyBar || stickyBar.dataset.opendotsStickyInit === 'true') {
    return;
  }

  stickyBar.dataset.opendotsStickyInit = 'true';

  if (stickyBar.parentElement !== document.body) {
    document.body.appendChild(stickyBar);
  }

  var bannerSelector = stickyBar.getAttribute('data-banner-selector') || '.section-opendots-2-banner';

  function updateOverviewStickyBar() {
    var banner = document.querySelector(bannerSelector);

    if (!banner) {
      return;
    }

    var bannerBottom = banner.getBoundingClientRect().bottom + window.scrollY;
    var isPastBanner = window.scrollY >= bannerBottom;

    stickyBar.classList.toggle('active', isPastBanner);
    document.body.classList.toggle('opendots-overview-sticky-active', isPastBanner);
  }

  updateOverviewStickyBar();
  window.addEventListener('scroll', updateOverviewStickyBar, { passive: true });
  window.addEventListener('resize', updateOverviewStickyBar);
});
